/* Gourdgeous Porches — booking flow + cart page (Aug-7 CART RESTRUCTURE).
 * One script, two pages:
 *   /pages/book — 3 steps: Package → Add-ons (ZIP gate) → Delivery week, ending in
 *     "Add to cart". ?edit=N reopens cart line N (button becomes "Update in cart");
 *     ?week=1 edits just the order's delivery week; ?zip=1 reopens the ZIP gate.
 *   /cart — the GP cart page: one line per configured package (pencil edit, qty
 *     stepper to duplicate, × remove), order rows (week/ZIP/zone fee/estimated tax),
 *     porch notes, sales-final acceptance, Checkout. Delivery details + promo codes
 *     are Shopify checkout's job now (standard checkout feel).
 * One order = one address + one delivery week + one visit; the week is set once and
 * any change updates every package — and it CLEARS when the last package leaves the
 * cart (Aug-12, Jeff: an empty cart has no week to deliver).
 * THE DELIVERY ZONE FEE IS NOT A CART LINE (changed Aug-12). Shopify asks the
 * gp-capacity backend for a delivery RATE against the address the customer types at
 * checkout, so the fee follows the real delivery address instead of the ZIP typed
 * while booking — those two could disagree, and did, in both directions. Every
 * surface here quotes the fee as a labeled ESTIMATE only, exactly like sales tax, and
 * "Total at checkout" is goods alone. Never add a fee line back into cartItems().
 * Draft persists in localStorage (v2, 7 days; the sales-final
 * checkbox NEVER persists); Checkout syncs the Shopify cart, replacing only booking
 * lines (gift cards ride along), then clears the draft — backing out of checkout
 * rebuilds the cart page from the Shopify cart itself.
 * ZIP allowlist = gourdeous.service_area_selection (via #gp-market-data); zone map =
 * gourdeous.delivery_zone_map, no map → in-area is free zone (never fake a mapping).
 * Text inputs are uncontrolled (no re-render while typing — focus survives).
 */
(function () {
  "use strict";

  var CFG = null, MD = null;

  function parseJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fmt(n) {
    var r = Math.round(n * 100) / 100;
    return "$" + r.toLocaleString("en-US", { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Horizon scrolls .page-wrapper, not the window. */
  function scroller() {
    var pw = document.querySelector(".page-wrapper");
    if (pw && pw.scrollHeight > pw.clientHeight) return pw;
    return document.scrollingElement || document.documentElement;
  }
  function toTop() { scroller().scrollTo({ top: 0, behavior: "smooth" }); }

  /* `note` is the line under the ZIP gate. It must not say delivery is included —
     it's a charge now, quoted at checkout against the address the customer types
     there (Aug-12, Jeff). What's said here is a preview of that charge, so it's
     worded as one; the fees mirror the backend's ZONE_TIERS. */
    /* RAISED 2026-10-26 (Jeff): 0/25/50 -> 39/69/99. MUST stay identical to ZONE_TIERS
     in the backend's web/lib/deliveryZones.js — the fee quoted here while booking and
     the fee Shopify charges at checkout come from two files on purpose, and they drift
     the moment one moves alone. That drift is the exact bug this path exists to fix.
     Basis: claude/delivery-zone-fee-raise-2026-10-26.md.
     NOTE "free" is a historical key name and is no longer free. */
  var ZONES = {
    free:  { fee: 39, gate: "$39 standard delivery zone", short: "Standard zone", note: "Delivery and placement to your ZIP run $39, added at checkout." },
    ext:   { fee: 69, gate: "$69 extended delivery zone", short: "Extended zone", note: "Delivery and placement to your ZIP run $69 for the extra distance, added at checkout." },
    outer: { fee: 99, gate: "$99 outer delivery zone", short: "Outer zone", note: "Delivery and placement to your ZIP run $99 for the extra distance, added at checkout." }
  };
  var MAX_QTY = 9;

  /* Later packages (and line edits) inherit the order's week — one address, one
     visit, one week — so their flow is 2 steps ending "Add to cart" right on the
     add-ons step. Only the first package (or ?week=1) sees the week step. */
  function inheritsWeek() {
    return !!state.week && !state.weekOnly && (state.entries.length > 0 || state.editIndex !== null);
  }
  /* Aug-11 (Jeff): the package-picker step is GONE. Packages are chosen on
     /pages/packages; this page only ever configures an already-chosen package.
     Internal step indices are UNCHANGED (1 = add-ons, 2 = delivery week) so the
     step logic below still reads the same — step 0 simply no longer exists and
     any entry without a package redirects to /pages/packages. */
  function stepLabels() {
    return inheritsWeek() ? ["Add-ons"] : ["Add-ons", "Delivery week"];
  }
  function labelIndex(step) { return step - 1; }

  /* Owner-approved acceptance copy (Aug-5, handoff open item #1).
     Rules: the term is stated in the label itself; NEVER pre-ticked.
     Aug-12 (Jeff): "§5"/"§10" read as mystery symbols — spell out "Policy section N". */
  var TERMS_COPY = "I agree and understand all sales are final — my order cannot be cancelled or refunded for any reason. My options are one same-metro transfer (Policy section 5) and the defect remedies (Policy section 10). Mums require my care and are not replaced after delivery.";
  /* Aug-12 (Jeff): the whole sentence used to be a <label>, so any click on it
     ticked the box — including a click meant for a policy reference. The row is
     no longer a label: ONLY the box toggles the term, and the two section
     references are real deep links to the policy page. The box keeps the full
     sentence as its accessible name via aria-labelledby, so screen readers and
     the checkbox's own hit target are unchanged. New tab on purpose: the tick
     deliberately never persists (see draft persistence), so navigating away in
     the same tab would silently un-tick a box the customer already checked. */
  function termsHtml() {
    var a = '<a class="terms-plink" target="_blank" rel="noopener" href="/pages/policies#policy-';
    return esc(TERMS_COPY)
      .replace("Policy section 5", a + '5">Policy section 5</a>')
      .replace("Policy section 10", a + '10">Policy section 10</a>');
  }

  /* Mums pre-purchase disclosures (Aug-10, attorney-required) — condensed from the
     live Policies §10 (48-hour arrival-defect remedy), §9 (Weather Guard is not heat
     protection), and the established living-plants product copy. Shown ON the row /
     line itself, never behind a tooltip. Quiet styling per owner direction.
     NOTE: the cited source doc claude/customer-policies.md was not found in the repo —
     wording flagged to Jeff for attorney sign-off. */
  var MUMS_CARE = "Daily watering is up to you; Weather Guard doesn’t cover mums, and mums that decline after delivery aren’t replaced — damage on arrival is covered.";
  /* "§10" read as a mystery symbol (Jeff, Aug-11) — spell it out as a link. */
  var MUMS_LINK = ' <a class="mums-plink" href="/pages/policies#policy-10">Read the mums policy →</a>';
  var MUMS_CARE_FULL = "Mums are living plants, not harvested decorations — daily watering is up to you; Weather Guard doesn’t cover mums, and mums that decline after delivery aren’t replaced (arrival damage covered — Policy section 10).";
  /* Cart-line version, one short line (Jeff, Aug-11) — the full sentence still
     appears in the sales-final terms label, where it gets signed. */
  var MUMS_CART = "Mums are living plants — daily watering is up to you; not replaced after delivery (damage on arrival is covered).";
  var MUMS_PHX = "October heat is hard on mums and decline is more likely — by including mums you accept that risk.";
  function isPhoenix() { return marketKey() === "phoenix"; }

  var state = {
    step: 0,
    pkg: null, on: {}, aqty: {},          /* the package being configured */
    entries: [],                          /* cart lines: {pkg, on, aqty, qty} */
    editIndex: null, weekOnly: false,     /* flow modes: editing a cart line / just the week */
    zip: "", zipOpen: false, zipEditing: false, week: null, marketOverride: null,
    removalWeek: "halloween",             /* which Season removal week — see weekChoice helpers */
    notes: "",
    waitJoined: false, avail: null,
    submitting: false, termsAccepted: false, photoOk: false
  };

  /* ---------- market ---------- */
  var MARKET_ALIASES = { "omaha-lincoln": "omaha", "omaha_lincoln": "omaha" };
  function marketKey() {
    var d = MD, fallback = (d && d.defaultMetro) || "denver";
    if (state.marketOverride && d && d.markets[state.marketOverride]) return state.marketOverride;
    var q = null;
    try { q = new URLSearchParams(location.search).get("market"); } catch (e) {}
    if (q) q = MARKET_ALIASES[q] || q;
    if (q && d && d.markets[q]) return q;
    if (window.GPMetro) {
      var m = window.GPMetro.get();
      if (d && d.markets[m]) return m;
    }
    return fallback;
  }
  function market() { return MD.markets[marketKey()]; }

  /* ---------- ZIP / zones ---------- */
  function zipDigits() { return state.zip.replace(/\D/g, ""); }
  function resolveZip(zip) {
    var z = MD && MD.zips;
    if (!z) return null;
    var sel = z.selection && typeof z.selection === "object" ? z.selection : z;
    for (var mk in sel) {
      if (Array.isArray(sel[mk]) && sel[mk].indexOf(zip) !== -1) return mk;
    }
    return null;
  }
  function zipStatus() {
    var d = zipDigits();
    if (d.length !== 5) return { status: "idle" };
    var mk = resolveZip(d);
    if (mk === marketKey()) return { status: "ok" };
    if (mk) return { status: "other", other: mk };
    return { status: "out" };
  }
  function switchMarket(mk) {
    if (!MD.markets[mk]) return;
    state.marketOverride = mk;
    if (window.GPMetro) { try { window.GPMetro.set(mk); } catch (e) {} }
    if (state.week && !bookableWeeks(mk).some(function (w) { return w.label === state.week; })) state.week = null;
  }
  function zoneKey() {
    if (zipStatus().status !== "ok") return null;
    var d = zipDigits(), map = CFG.zoneMap;
    if (map) {
      if (Array.isArray(map.outer) && map.outer.indexOf(d) !== -1) return "outer";
      if (Array.isArray(map.ext) && map.ext.indexOf(d) !== -1) return "ext";
    }
    return "free"; /* no zone map yet → in-area is free (mechanism ready for the real lists) */
  }
  function zone() { var k = zoneKey(); return k ? ZONES[k] : null; }

  /* ---------- catalog helpers ---------- */
  function pkgOf(id) { return CFG.packages.find(function (p) { return p.id === id; }); }
  function addonById(id) { return CFG.addons.find(function (a) { return a.id === id; }); }
  function entryIncl(a, e) { return !!(a.incl && a.incl.indexOf(e.pkg) !== -1); }
  function entryPrice(a, e) { return a.byPkg ? (a.byPkg[e.pkg] || a.price || 0) : a.price; }
  /* Aug-12: an add-on may be withheld from a metro. Weather Guard is Denver/Omaha/Lincoln
     only — Phoenix sees no frost until December and its window closes Oct 17, so there is
     nothing to protect against. Data-driven (`excludeMetros`) rather than an id check, and it lives
     in the theme because product bodies stay metro-neutral. */
  function entryOffered(a) {
    var mk = marketKey();
    if (a.excludeMetros && a.excludeMetros.indexOf(mk) !== -1) return false;
    /* The inverse gate (Aug-13): ornamental grass is the accent in Phoenix ONLY,
       where heat makes mums unviable. The two are a swap, not an addition — mums
       carry excludeMetros for the same metro, so exactly one of them ever shows. */
    if (a.onlyMetros && a.onlyMetros.indexOf(mk) === -1) return false;
    return true;
  }
  /* Per-tier copy that one Shopify product body can't hold — e.g. Weather Guard's panel count. */
  function entrySub(a, e) { return (e && a.subByPkg && a.subByPkg[e.pkg]) || a.sub; }
  function entryQty(a, e) { return (e.aqty && e.aqty[a.id]) || 1; }
  function entryAPrice(a, e) { return a.qty ? entryPrice(a, e) * entryQty(a, e) : entryPrice(a, e); }

  /* ---------- week-choice add-ons ----------
     An add-on carrying `weekChoice` + `variantByPkgWeek` sells the same tier ladder in
     more than one week — today only Season removal (Halloween vs Thanksgiving), whose
     Shopify product is "Removal week" × "Package" = 8 variants. Everything here keys off
     the DATA, never off the id "removal", so a second such add-on needs no new code.
     The choice is ORDER-level, like the delivery week: one visit back, so changing it on
     one package changes it for the whole order. */
  function weekChoiceAddon() {
    return CFG.addons.find(function (a) { return a.weekChoice && a.variantByPkgWeek; });
  }
  function weekChoiceKey(v) {
    var a = weekChoiceAddon();
    if (!a) return v || null;
    var ok = (a.weekChoice.options || []).some(function (o) { return o.value === v; });
    return ok ? v : a.weekChoice.default;
  }
  function weekChoiceLabel(a, v) {
    var hit = (a.weekChoice.options || []).find(function (o) { return o.value === v; });
    return hit ? hit.label : "";
  }
  /* The single place a chosen add-on turns into a variant id. Week-aware first, then the
     flat per-package map, then a single variant. The `variantByPkg` branch deliberately
     does NOT fall through to `variantId`: design and Weather Guard have no estate key and
     no flat variantId, and cartItems() relies on the resulting undefined to skip them. */
  function addonVariant(a, e) {
    if (a.variantByPkgWeek) {
      var byWeek = a.variantByPkgWeek[state.removalWeek] || a.variantByPkgWeek[a.weekChoice && a.weekChoice.default];
      if (byWeek) return byWeek[e.pkg];
    }
    return a.variantByPkg ? a.variantByPkg[e.pkg] : a.variantId;
  }
  /* The photo release is only offered when a designer actually styled the porch:
     design bought as an add-on, or included at the Estate. A drop-off we never
     arranged isn't our work to show. */
  function hasDesign() {
    return state.entries.some(function (e) {
      var d = addonById("design");
      return !!d && (entryIncl(d, e) || !!e.on[d.id]);
    });
  }
  function entryChosen(e) {
    /* entryOffered is filtered HERE, not only at render: this is the one chokepoint feeding
       both entryUnitTotal() and the checkout line items. A guard selected in Denver and then
       carried into Phoenix by a metro switch or a restored cart would otherwise stay in
       `on` — priced and charged for a product we do not sell there. */
    return CFG.addons.filter(function (a) { return e.on[a.id] && !entryIncl(a, e) && entryOffered(a); });
  }
  function config() { return state.pkg ? { pkg: state.pkg, on: state.on, aqty: state.aqty } : null; }
  function entryUnitTotal(e) {
    return pkgOf(e.pkg).price + entryChosen(e).reduce(function (s, a) { return s + entryAPrice(a, e); }, 0);
  }
  function entrySubs(e) {
    var names = entryChosen(e).map(function (a) {
      return a.qty && entryQty(a, e) > 1 ? a.name + " × " + entryQty(a, e) : a.name;
    });
    return names.length ? names.join(" · ") : "No add-ons";
  }
  function cartCount() {
    return state.entries.reduce(function (n, e) { return n + (e.qty || 1); }, 0);
  }
  /* Cart money: fee once per order; estimated tax on goods only (packages + material
     add-ons), matching Shopify's per-product tax setup. Checkout computes the real tax. */
  /* Non-booking lines living in the Shopify cart (gift cards, mainly). Held at
     module level, NOT on state, so it never persists into the draft — it's
     re-read from /cart.js on every cart page load. cartMoney() has to see it or
     the panel quotes a total Shopify checkout won't honour (Jeff, Aug-12: a
     gift-card-only cart read "Total at checkout $0" and opened at $450). */
  var extraCart = [];
  function extrasTotal() {
    return extraCart.reduce(function (s2, it) { return s2 + (it.line_price || 0) / 100; }, 0);
  }
  function extrasCount() {
    return extraCart.reduce(function (n, it) { return n + (it.quantity || 1); }, 0);
  }
  function cartMoney() {
    var mk = marketKey(), z = zone(), fee = z ? z.fee : 0;
    var pkgTotal = 0, addonsTotal = 0, goodsAddons = 0;
    state.entries.forEach(function (e) {
      var q = e.qty || 1;
      pkgTotal += pkgOf(e.pkg).price * q;
      entryChosen(e).forEach(function (a) {
        var p = entryAPrice(a, e) * q;
        addonsTotal += p;
        if (!a.service) goodsAddons += p;
      });
    });
    var rate = (CFG.tax && CFG.tax[mk]) || 0;
    /* Gift cards are deliberately OUT of the taxable base — a gift card isn't
       taxed when bought, only when it's redeemed against goods. */
    var tax = Math.round((pkgTotal + goodsAddons) * rate * 100) / 100;
    var extras = extrasTotal();
    /* Aug-12 (Jeff): totals must MATCH from nav chip → cart → Shopify checkout.
       `due` is the exact figure checkout greets them with, and as of the carrier
       service THE ZONE FEE IS NO LONGER A CART LINE — Shopify prices it as a
       shipping rate from the address the customer types at checkout, which is the
       only way it can't disagree with the ZIP typed here. Checkout therefore opens
       at goods alone; fee and tax are both labeled estimates, never folded into the
       headline. `total` keeps the all-in estimate for anywhere that wants it. */
    var sub = pkgTotal + addonsTotal + extras;
    return { subtotal: sub, fee: fee, tax: tax, extras: extras, due: sub, total: sub + fee + tax };
  }

  /* ---------- weeks / availability ---------- */
  /* Sept-29 (Jeff): past windows were still showing as Open. A week leaves the
     list the day it begins — its Monday is too late to book a visit inside it —
     so the grid, saved drafts, and carts rebuilt from checkout all stop offering
     it at once, with no mid-season data edit. Dates compare as local YYYY-MM-DD
     strings; a week without a "start" never expires. */
  function bookableWeeks(mk) {
    var n = new Date();
    var today = n.getFullYear() + "-" + ("0" + (n.getMonth() + 1)).slice(-2) + "-" + ("0" + n.getDate()).slice(-2);
    return (CFG.weeks[mk] || []).filter(function (w) { return !w.start || w.start > today; });
  }
  /* Oct-8 (Jeff): the Open / A few left / Sold out chips are GONE — they
     counted bookings against the retired scarcity caps, and nothing tracks
     real inventory. A week is just a pickable date range; past weeks still
     drop off by date (bookableWeeks). Don't reintroduce availability
     statuses without Jeff asking. */
  function weeks() {
    return bookableWeeks(marketKey()).map(function (w) {
      return { label: w.label, range: w.range };
    });
  }

  /* ---------- draft persistence (v2 — cart model) ----------
     Cart lines + the in-progress config + zip/week/notes save on every render, for up
     to 7 days. termsAccepted deliberately NEVER persists — it is a fresh acceptance
     every time. photoOk DOES persist: it is an optional preference the customer
     ticked, not a term they must re-affirm, and losing it on reload is just friction. summary feeds the nav cart
     icon (gp-home.js). Draft clears at checkout handoff; backing out of checkout
     rebuilds from the Shopify cart. */
  var DRAFT_KEY = "gp-booking-draft";
  /* Aug-12 (Jeff): the nav bag total is drawn by gp-home.js FROM THIS DRAFT, and it
     only re-read it on page load / pageshow — so anything that changed the total in
     place (ZIP moving between zone-fee tiers, qty stepper, remove) left the chip
     showing the old number while the panel showed the new one. saveDraft now says
     so out loud and gp-home re-reads. Only on a real change: notes typing calls
     saveDraft on every keystroke and must not spam the listener. */
  var lastCartSig = null;
  function announceCart(sig, detail) {
    if (sig === lastCartSig) return;
    lastCartSig = sig;
    try { document.dispatchEvent(new CustomEvent("gp:cart", { detail: detail || null })); } catch (e) {}
  }
  /* On /cart we know the exact figure the panel is showing, so we hand it over
     rather than let gp-home.js re-derive it from the draft — the draft counts
     packages only, and a gift-card-only cart has none (it went blank under a
     panel reading $450). Anywhere else the draft/cart.js path still applies. */
  function announceCartExact(due) {
    announceCart("exact|" + due + "|" + (cartCount() + extrasCount()),
      { total: due, count: cartCount() + extrasCount() });
  }
  function saveDraft() {
    try {
      if (!state.pkg && !state.entries.length && !zipDigits() && !state.week) {
        localStorage.removeItem(DRAFT_KEY);
        announceCart("empty");
        return;
      }
      var count = cartCount(), total = cartMoney().due;
      localStorage.setItem(DRAFT_KEY, JSON.stringify({
        v: 2, at: Date.now(),
        state: {
          config: { pkg: state.pkg, on: state.on, aqty: state.aqty },
          entries: state.entries, zip: state.zip, week: state.week,
          removalWeek: state.removalWeek,
          marketOverride: state.marketOverride, notes: state.notes, photoOk: state.photoOk
        },
        summary: { count: count, total: total }
      }));
      var saved = document.querySelector("[data-bk-bar-saved]");
      if (saved) saved.hidden = false;
      announceCart(count + "|" + total);
    } catch (e) {}
  }
  function loadDraft() {
    try {
      var d = JSON.parse(localStorage.getItem(DRAFT_KEY));
      if (!d || d.v !== 2 || !d.state) { if (d) localStorage.removeItem(DRAFT_KEY); return null; }
      if (Date.now() - (d.at || 0) > 7 * 864e5) { localStorage.removeItem(DRAFT_KEY); return null; }
      return d.state;
    } catch (e) { return null; }
  }
  function clearDraft() { try { localStorage.removeItem(DRAFT_KEY); } catch (e) {} }
  function applyDraft(restored) {
    var cfg = restored.config || {};
    state.pkg = cfg.pkg && pkgOf(cfg.pkg) ? cfg.pkg : null;
    state.on = cfg.on || {};
    state.aqty = cfg.aqty || {};
    state.entries = (restored.entries || []).filter(function (e) { return e && pkgOf(e.pkg); })
      .map(function (e) { return { pkg: e.pkg, on: e.on || {}, aqty: e.aqty || {}, qty: Math.min(Math.max(e.qty || 1, 1), MAX_QTY) }; });
    state.zip = restored.zip || "";
    state.week = restored.week || null;
    state.removalWeek = weekChoiceKey(restored.removalWeek);
    state.notes = restored.notes || "";
    state.photoOk = !!restored.photoOk;
    state.marketOverride = restored.marketOverride && MD.markets[restored.marketOverride] ? restored.marketOverride : null;
    if (state.week && !bookableWeeks(marketKey()).some(function (w) { return w.label === state.week; })) state.week = null;
  }

  /* ---------- Shopify cart sync ---------- */
  function bookingVariantSet() {
    var set = {};
    CFG.packages.forEach(function (p) { set[p.variantId] = true; });
    CFG.addons.forEach(function (a) {
      if (a.variantId) set[a.variantId] = true;
      if (a.variantByPkg) Object.keys(a.variantByPkg).forEach(function (k) { set[a.variantByPkg[k]] = true; });
      /* EVERY week of a week-choice add-on is ours, not just the one currently selected.
         Miss this and a Thanksgiving removal line sitting in a returning cart is invisible
         to the sync: not recognized, not replaced, and it rides to checkout beside the new
         line as a duplicate the customer pays for. Same failure the legacy fee variants
         below were kept around to prevent. */
      if (a.variantByPkgWeek) Object.keys(a.variantByPkgWeek).forEach(function (wk) {
        var m = a.variantByPkgWeek[wk];
        Object.keys(m).forEach(function (pk) { set[m[pk]] = true; });
      });
    });
    /* The retired zone-fee variants are still claimed as OURS, purely so a fee line
       sitting in a cart from before the carrier service gets zeroed out on the next
       sync instead of surviving as an orphan the flow won't touch — which would bill
       the customer for delivery twice, once as a product and once as the shipping
       rate. Nothing adds these any more; see cartItems(). Safe to drop once no live
       cart can still hold one. */
    (CFG.legacyFeeVariants || []).forEach(function (vid) { set[vid] = true; });
    return set;
  }
  /* Rebuild cart lines from the Shopify cart (customer backed out of checkout). */
  function rebuildFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    var byVid = {};
    CFG.packages.forEach(function (p) { byVid[p.variantId] = { kind: "pkg", id: p.id }; });
    CFG.addons.forEach(function (a) {
      if (a.variantId) byVid[a.variantId] = { kind: "addon", id: a.id };
      if (a.variantByPkg) Object.keys(a.variantByPkg).forEach(function (pk) {
        byVid[a.variantByPkg[pk]] = { kind: "addon", id: a.id };
      });
      /* Registered AFTER variantByPkg on purpose. The default week's four ids appear in
         both maps, and the week-aware entry has to win so a restored draft can tell which
         week the customer actually bought instead of silently reverting to the default. */
      if (a.variantByPkgWeek) Object.keys(a.variantByPkgWeek).forEach(function (wk) {
        var m = a.variantByPkgWeek[wk];
        Object.keys(m).forEach(function (pk) {
          byVid[m[pk]] = { kind: "addon", id: a.id, weekKey: wk };
        });
      });
    });
    var groups = {}, order = [], found = false, foundWeekKey = null;
    cart.items.forEach(function (it) {
      var m = byVid[it.variant_id];
      if (!m) return; /* zone fee (derived) and non-booking items are skipped */
      found = true;
      var key = (it.properties && it.properties.Package) || "single";
      if (!groups[key]) { groups[key] = { pkg: null, on: {}, aqty: {}, qty: 1, _addonQ: {} }; order.push(key); }
      if (m.kind === "pkg") { groups[key].pkg = m.id; groups[key].qty = Math.min(it.quantity || 1, MAX_QTY); }
      else {
        groups[key].on[m.id] = true; groups[key]._addonQ[m.id] = it.quantity || 1;
        /* the variant itself is the authority on which week was bought — the line
           property is display only and a customer could be returning from a cart
           built before that property existed */
        if (m.weekKey) foundWeekKey = m.weekKey;
      }
    });
    if (!found) return false;
    var ents = order.map(function (k) { return groups[k]; }).filter(function (e) { return e.pkg; });
    if (!ents.length) return false;
    ents.forEach(function (e) {
      Object.keys(e._addonQ).forEach(function (id) {
        var a = addonById(id);
        if (a && a.qty) e.aqty[id] = Math.max(1, Math.round(e._addonQ[id] / (e.qty || 1)));
      });
      delete e._addonQ;
    });
    var attrs = cart.attributes || {};
    if (attrs["Metro"]) {
      for (var k in MD.markets) {
        if (MD.markets[k].label === attrs["Metro"]) { state.marketOverride = k; break; }
      }
    }
    state.entries = ents;
    if (attrs["Delivery ZIP"]) state.zip = String(attrs["Delivery ZIP"]);
    var wk = attrs["Delivery week"];
    if (wk && bookableWeeks(marketKey()).some(function (w) { return w.label === wk; })) state.week = wk;
    if (foundWeekKey) state.removalWeek = weekChoiceKey(foundWeekKey);
    state.notes = cart.note || "";
    return true;
  }
  function cartItems() {
    var multi = state.entries.length > 1;
    var items = [];
    state.entries.forEach(function (e, i) {
      var q = e.qty || 1;
      var props = (multi || q > 1) ? { Package: "Package " + (i + 1) } : undefined;
      /* Delivery week rides as a visible line-item property on the PACKAGE line —
         cart attributes never display at Shopify checkout, and the week is the one
         detail the customer must see at the payment moment.
         Porch notes ride along for the same reason (Aug-13, Jeff): they were only
         being sent as the cart NOTE, which reaches the admin order but is shown to
         the customer nowhere — not at checkout, not on the confirmation. The note is
         still sent as well, so the admin order keeps it in its usual place. */
      var pkgProps = props ? Object.assign({}, props) : {};
      if (state.week) pkgProps["Delivery week"] = state.week;
      var porch = (state.notes || "").trim();
      if (porch) pkgProps["Porch notes"] = porch;
      items.push({ id: pkgOf(e.pkg).variantId, quantity: q, properties: Object.keys(pkgProps).length ? pkgProps : undefined });
      entryChosen(e).forEach(function (a) {
        var vid = addonVariant(a, e);
        if (!vid) return;
        /* The chosen week is already in the variant title, but the line PROPERTY is what
           shows up consistently on packing slips and in exports — the same reason the
           delivery week rides on the package line above rather than as a cart attribute. */
        var aProps = props ? Object.assign({}, props) : {};
        if (a.weekChoice && a.variantByPkgWeek) {
          aProps[a.weekChoice.property || "Removal week"] = weekChoiceLabel(a, state.removalWeek);
        }
        items.push({
          id: vid, quantity: (a.qty ? entryQty(a, e) : 1) * q,
          properties: Object.keys(aProps).length ? aProps : undefined
        });
      });
    });
    /* The zone fee used to be pushed here as a line item priced from the ZIP above.
       It is NOT any more (Aug-12, Jeff): Shopify now asks gp-capacity for the rate
       against the address typed at checkout, so the fee follows the real delivery
       address instead of whatever ZIP was typed while booking. Those two could
       disagree, and did — booked from a free ZIP and shipped to a $25 one, the fee
       was never charged; the reverse overcharged on an all-sales-final order.
       Do not reinstate a fee line here. bookingVariantSet() still lists the retired
       fee variants on purpose (CFG.legacyFeeVariants), so a stale fee line from an
       older cart gets zeroed out on the next checkout sync. */
    return items;
  }
  /* When checkout can't proceed, say why and point at it — a silent faded button
     leaves the buyer stuck (visibility of status; staff-designer pass, Aug-11). */
  function checkoutBlocker() {
    if (!state.entries.length && !extrasTotal()) return { msg: "Your cart is empty — add a package first." };
    /* Week, ZIP and the sales-final terms are PACKAGE requirements. A cart
       holding only a gift card has nothing to deliver and nothing to make
       final, so it must not be held behind them. */
    if (!state.entries.length) return null;
    if (!state.week) return { msg: "Pick a delivery week first — use Change in the order summary." };
    if (zipStatus().status !== "ok") return { msg: "Confirm your delivery ZIP first — use Edit in the order summary." };
    if (!state.termsAccepted) return { msg: "One step left: check the box above to confirm the sales-final terms.", target: ".gpc-terms" };
    return null;
  }
  function submitCheckout(btn, msgEl) {
    if (state.submitting) return;
    var blocked = checkoutBlocker();
    if (blocked) {
      if (msgEl) { msgEl.textContent = blocked.msg; msgEl.hidden = false; }
      if (blocked.target) {
        var t = document.querySelector(blocked.target);
        if (t) {
          t.scrollIntoView({ block: "center" });
          t.classList.add("is-attn");
          setTimeout(function () { t.classList.remove("is-attn"); }, 1800);
        }
      }
      return;
    }
    state.submitting = true;
    if (btn) { btn.classList.add("is-disabled"); btn.textContent = "One moment…"; }
    /* With no packages left (gift card only, or every package removed) there is
       nothing to add and no delivery details to stamp — but the zero-out below
       STILL has to run, or booking lines left in the Shopify cart from an earlier
       checkout would be charged for packages the customer removed. */
    var items = cartItems();
    var z = zone();
    var attrs = !items.length ? null : {
      "Delivery week": state.week || "",
      "Delivery ZIP": zipDigits(),
      "Delivery zone": z ? z.short : "",
      "Metro": market().label,
      "Policy acceptance": "All-sales-final terms accepted in cart — v2026-08-11"
    };
    /* Recorded either way when asked, so the photographer has an answer rather than
       an absence. Omitted entirely when there is no design — a blank field would
       read as a refusal we never sought. */
    if (attrs && hasDesign()) attrs["Photography permission"] = state.photoOk ? "Granted" : "Not granted";
    var known = bookingVariantSet();
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* zero out existing BOOKING lines only — gift cards etc. stay */
        var updates = {};
        (cart.items || []).forEach(function (it) {
          if (known[it.variant_id]) updates[it.key] = 0;
        });
        if (Object.keys(updates).length) {
          return fetch("/cart/update.js", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          });
        }
      })
      .then(function () {
        if (!items.length) return null; /* /cart/add.js rejects an empty items list */
        return fetch("/cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (r && !r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || "Cart error"); });
        if (!attrs) return null;
        return fetch("/cart/update.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: attrs, note: (state.notes || "").trim() })
        });
      })
      .then(function () { clearDraft(); location.href = "/checkout"; })
      .catch(function (err) {
        state.submitting = false;
        if (btn) { btn.classList.remove("is-disabled"); btn.textContent = "Checkout"; }
        if (msgEl) {
          msgEl.hidden = false;
          msgEl.textContent = "We couldn’t start checkout — " + (err && err.message ? err.message : "please try again") + ". If booking hasn’t opened yet, packages can’t be reserved.";
        }
      });
  }

  /* ============================================================
     PAGE: BOOKING FLOW (/pages/book)
     ============================================================ */
  var PAGE = null;

  function go(step) { state.step = step; render(); toTop(); }

  function renderStepper() {
    /* Aug-11 (Jeff): "Packages" shows as step 01 even though choosing happens on
       /pages/packages — always rendered done, and it links back there. The page's
       own steps follow as 02+. */
    var host = document.querySelector("[data-bk-stepper]");
    var labels = stepLabels();
    var html = '<a class="stp is-done" href="/pages/packages"><span class="n">01</span><span class="l">Packages</span></a><span class="stp-rule"></span>';
    labels.forEach(function (label, i) {
      var step = i + 1; /* label 0 is step 1 — the picker step is gone */
      var cls = step === state.step ? " is-active" : (step < state.step ? " is-done" : "");
      html += '<button class="stp' + cls + '" type="button" data-bk-goto="' + step + '"' + (step < state.step ? "" : ' tabindex="-1"') + '><span class="n">0' + (i + 2) + '</span><span class="l">' + label + "</span></button>";
      if (i < labels.length - 1) html += '<span class="stp-rule"></span>';
    });
    /* Aug-13 (Jeff): when the week is INHERITED from an earlier package the flow has
       no step 2, so stepLabels() drops it and the stepper showed only two chips — the
       journey looked shorter than the order actually is. The customer still has a
       delivery week; it was just decided earlier. Render it as done rather than hide
       it. Presentational only: no data-bk-goto, because step 2 does not exist in this
       mode and routing into it would strand the package being configured. The week
       stays changeable from the order summary's Change link. */
    if (inheritsWeek()) {
      html += '<span class="stp-rule"></span>' +
        '<span class="stp is-done" aria-disabled="true"><span class="n">03</span><span class="l">Delivery week</span></span>';
    }
    host.innerHTML = html;
    host.querySelectorAll("[data-bk-goto]").forEach(function (b) {
      var i = +b.getAttribute("data-bk-goto");
      if (i < state.step) b.addEventListener("click", function () { go(i); });
    });
  }

  function pkgPhoto(p) {
    var m = market();
    return (m && m[p.photoKey]) || "";
  }
  /* renderStep1 (the "Choose your package." picker) was REMOVED Aug-11 per Jeff —
     it duplicated /pages/packages. Package choice happens there; this page starts
     at add-ons. Do not reinstate a picker step here. */

  /* While the Switch/Keep package prompt is open, add-ons are ambiguous (which
     package would they belong to?) — lock them until the choice is made. */

  function zipMsgFor(zs) {
    var z = zone();
    if (zs.status === "ok") return "You’re in our " + z.gate + ".";
    if (zs.status === "other") return "That ZIP is in our " + MD.markets[zs.other].label + " area — switching you over.";
    if (zs.status === "out") return "We’re not in your neighborhood yet — leave your email and you’ll be the first to know when our crews reach your street.";
    return "Enter your ZIP to unlock add-ons and delivery weeks.";
  }
  function renderStep2() {
    var d = config(), zs = zipStatus(), ok = zs.status === "ok";
    var locked = !ok;
    var pkgName = d ? pkgOf(d.pkg).name : "it";
    var html = '<section class="bstep" aria-label="Step 2: Add-ons">';
    html += "<h2>Make " + esc(pkgName) + " yours.</h2>";
    /* Aug-11 (Jeff): say plainly that this step is about add-ons; the
       "Change package" link is gone — packages change on /pages/packages. */
    html += '<p class="shint">' + (ok ? "Choose your add-ons — tap to add, tap again to remove. Happy with the package as is? Skip ahead." : "First, confirm your ZIP — then choose your add-ons.") + "</p>";

    {
      /* v4, final (Aug-12): the gate is a PERMANENT inline-validated field — no
         collapse, no strip, no modes. Confirmation is a ✓ inside the field and
         the answer text in a space reserved for it, so the gate's geometry never
         changes and nothing below it ever moves. Edit = just tap the field. */
      var msgCls = ok ? "ok" : (zs.status === "idle" ? "" : "out");
      html += '<div class="zipgate ' + (ok ? "is-ok" : "is-active") + '" data-bk-zipgate>' +
        '<div class="zg-field"><label for="bk-zipcheck">Your ZIP code</label><span class="zg-inputwrap"><input id="bk-zipcheck" inputmode="numeric" maxlength="5" placeholder="80209" value="' + esc(state.zip) + '"><span class="zg-check" aria-hidden="true">✓</span></span></div>' +
        '<div class="zg-body"><p class="zg-msg ' + msgCls + '" data-bk-zipmsg aria-live="polite">' + esc(zipMsgFor(zs)) + "</p>" +
        (ok ? '<p class="zg-sub">' + esc(zone().note) + "</p>" : "") +
        (zs.status === "out" ? (state.waitJoined
          ? '<p class="gz-joined">You’re on the list — we’ll write the moment we expand ✓</p>'
          : '<form class="wait-row" data-bk-wait><input type="email" required placeholder="you@example.com" aria-label="Email address"><button class="btn btn-ghost" type="submit">Join the waitlist</button></form>') : "") +
        "</div></div>";
    }
    html += '<p class="lock-note"' + (ok ? ' style="visibility:hidden"' : "") + '>Confirm your ZIP above to unlock add-ons.</p>';

    /* What the package already holds, right where add-ons get chosen — so nobody
       buys an extra of something their package includes (Jeff, Aug-11). */
    var pk = pkgOf(state.pkg);
    if (pk) {
      var pph = pkgPhoto(pk);
      html += '<div class="binside">' +
        (pph ? '<img class="binside-ph" alt="" src="' + esc(pph) + '">' : "") +
        '<span class="binside-body"><span class="binside-k">Already in ' + esc(pk.name) + '</span>' +
        /* Phoenix's included accent is grass, not mums — swap the label, keep the count */
        esc(isPhoenix() ? pk.items.replace("medium mums", market().accentLabelLower) : pk.items) +
        (pk.note ? ' · <b>' + esc(pk.note) + "</b>" : "") + "</span></div>";
    }

    html += '<div class="arows' + (locked ? " is-locked" : "") + '">';
    var lastGroup = null;
    CFG.addons.forEach(function (a) {
      /* Order matters. Metro exclusion is checked FIRST: an add-on we don't sell here is
         hidden outright, so a Phoenix Estate never sees a Weather Guard row claiming
         "Included" for something it doesn't get. Only then do we render inclusions. */
      if (!entryOffered(a)) return; /* Weather Guard is not sold in Phoenix at any tier (Aug-12) */
      if (a.group && a.group !== lastGroup) { html += '<div class="agroup-k">' + esc(a.group) + "</div>"; lastGroup = a.group; }
      /* Included add-ons used to be hidden entirely on the Estate. They now render as a
         non-interactive row reading "Included" (Jeff, Aug-12): hiding them made the
         highest tier look like it offered LESS than the ones below it, when the opposite
         is true. No checkbox, no data-bk-addon, no qty stepper — nothing to click, and
         entryChosen() still excludes them, so they can never reach the cart. */
      var incl = !!(d && entryIncl(a, d));
      var on = !!state.on[a.id];
      var price = d ? entryPrice(a, d) : (a.price || 0);
      var q = state.aqty[a.id] || 1;
      var amt = incl ? "Included" : (a.qty ? "$" + price + " ea" : "$" + price); /* per-unit price never changes on select; totals live in the summary */
      /* Aug-11 (Jeff): the row carries just the policy link (Phoenix keeps its
         heat-risk sentence — metro-specific term); the full care text lives at
         the policy and in the signed terms label. */
      var care = a.care ? '<small class="arow-care">' + (isPhoenix() ? esc(MUMS_PHX) + " " : "") + MUMS_LINK.replace(/^ /, "") + "</small>" : "";
      /* The Arizona heat note that stood here is retired (Aug-12): Weather Guard is no longer
         sold in Phoenix at all, so the row never renders there and the warning has nothing to
         warn about. Suppression happens above, via `excludeMetros`. */
      html += '<div class="arow' + (incl ? " is-incl" : (on ? " is-on" : "")) +
        (incl ? '"' : '" tabindex="' + (locked ? "-1" : "0") + '" role="checkbox" aria-checked="' + on + '" aria-disabled="' + locked + '" data-bk-addon="' + a.id + '"') + '>' +
        '<span class="check">✓</span>' +
        (a.img ? '<img class="athumb" alt="" loading="lazy" src="' + esc(a.img) + '">' : "") +
        '<span class="name">' + esc(a.name) + (a.tag ? '<span class="atag">' + esc(a.tag) + "</span>" : "") + "<small>" + esc(entrySub(a, d)) + "</small>" + care + "</span>" +
        (!incl && a.qty ? '<span class="qty' + (on ? "" : " is-ghost") + '"' + (on ? "" : ' aria-hidden="true"') + '><button type="button" data-bk-minus="' + a.id + '" aria-label="Fewer"' + (on ? "" : " tabindex=\"-1\"") + '>−</button><b>' + q + '</b><button type="button" data-bk-plus="' + a.id + '" aria-label="More"' + (on ? "" : " tabindex=\"-1\"") + '>+</button></span>' : "") +
        '<span class="amt">' + amt + "</span></div>";
      /* A SIBLING of the row, never a child: the row is role="checkbox" and swallows
         clicks, so nesting a second control inside it would both toggle the add-on and
         break the checkbox's accessible name. Only shown once the add-on is on — there
         is nothing to schedule until then. Both weeks cost the same, so nothing about
         the price summary changes when this moves. */
      if (!incl && on && a.weekChoice && a.variantByPkgWeek) {
        html += '<div class="awk" role="radiogroup" aria-label="' + esc(a.weekChoice.label) + '" data-bk-awk-group="' + esc(a.id) + '">' +
          '<span class="awk-k">' + esc(a.weekChoice.label) + "</span>" +
          '<span class="awk-opts">';
        (a.weekChoice.options || []).forEach(function (o) {
          var sel = state.removalWeek === o.value;
          /* roving tabindex: one stop for the whole group, arrows move within it */
          html += '<span class="awk-opt' + (sel ? " is-sel" : "") + '" role="radio"' +
            ' aria-checked="' + sel + '" aria-disabled="' + locked + '"' +
            ' tabindex="' + (locked ? "-1" : (sel ? "0" : "-1")) + '"' +
            ' data-bk-awk="' + esc(o.value) + '">' + esc(o.label) + "</span>";
        });
        html += "</span></div>";
      }
    });
    html += "</div>";
    if (inheritsWeek()) {
      /* week is inherited — this step ends the flow */
      var wkLc = state.week.charAt(0).toLowerCase() + state.week.slice(1);
      html += '<p class="window-note">Delivers the ' + esc(wkLc) + " with the rest of your order — the week can be changed in your cart.</p>";
      html += '<div class="stepnav"><button class="btn btn-ghost" type="button" data-bk-back>← Back</button>' +
        '<button class="btn btn-primary' + (locked ? " is-disabled" : "") + '" type="button" data-bk-addtocart>' +
        (state.editIndex !== null ? "Update in cart" : "Add to cart") + ' <span class="arrow">→</span></button></div></section>';
    } else {
      html += '<div class="stepnav"><button class="btn btn-ghost" type="button" data-bk-back>← Back</button>' +
        '<button class="btn btn-primary' + (locked ? " is-disabled" : "") + '" type="button" data-bk-next>Continue to delivery week <span class="arrow">→</span></button></div></section>';
    }
    return html;
  }

  function renderStep3() {
    var inherit = state.entries.length > 0 && state.editIndex === null && !state.weekOnly;
    var html = '<section class="bstep" aria-label="Step 3: Delivery week">';
    html += "<h2>" + (state.weekOnly ? "Change your delivery week." : "Pick your delivery week.") + "</h2>";
    html += '<p class="shint">' + (inherit || state.weekOnly || (state.editIndex !== null && state.entries.length > 1)
      ? "Your whole order delivers in one visit — changing the week updates every package."
      : "You pick the week — we’ll confirm your exact delivery day about a week ahead.") + "</p>";
    var wlist = weeks();
    if (!wlist.length) {
      html += '<p class="window-note">The last delivery week of the season has passed — booking is closed for this year.</p>';
      html += '<div class="stepnav"><button class="btn btn-ghost" type="button" data-bk-back>← Back</button></div></section>';
      return html;
    }
    html += '<div class="wgrid">';
    wlist.forEach(function (w) {
      var sel = state.week === w.label;
      html += '<button type="button" class="wcard' + (sel ? " is-sel" : "") + '" aria-pressed="' + sel + '" data-bk-week="' + esc(w.label) + '">' +
        '<span class="wk">' + esc(w.label) + '</span><span class="wrange">' + esc(w.range) + '</span></button>';
    });
    html += "</div>";
    html += '<p class="window-note">No need to be home — your crew delivers and styles everything at the door. All packages on your order are styled in the same visit.</p>';
    var label = state.weekOnly ? "Save delivery week <span class=\"arrow\">→</span>"
      : (state.editIndex !== null ? "Update in cart <span class=\"arrow\">→</span>" : "Add to cart <span class=\"arrow\">→</span>");
    html += '<div class="stepnav"><button class="btn btn-ghost" type="button" data-bk-back>← Back</button>' +
      '<button class="btn btn-primary' + (state.week ? "" : " is-disabled") + '" type="button" data-bk-addtocart>' + label + "</button></div></section>";
    return html;
  }

  function addToCart() {
    if (!state.week) return;
    /* pin the resolved metro into the draft so /cart (no ?market=) agrees —
       weeks, tax, and the Phoenix mums disclosure all key off it */
    state.marketOverride = marketKey();
    if (state.weekOnly) { state.weekOnly = false; saveDraft(); location.href = "/cart"; return; }
    var cfg = { pkg: state.pkg, on: state.on, aqty: state.aqty };
    if (!cfg.pkg) return;
    if (state.editIndex !== null && state.entries[state.editIndex]) {
      state.entries[state.editIndex] = { pkg: cfg.pkg, on: cfg.on, aqty: cfg.aqty, qty: state.entries[state.editIndex].qty || 1 };
    } else {
      state.entries.push({ pkg: cfg.pkg, on: cfg.on, aqty: cfg.aqty, qty: 1 });
    }
    state.pkg = null; state.on = {}; state.aqty = {}; state.editIndex = null;
    saveDraft();
    location.href = "/cart";
  }

  /* Aug-11 (Jeff): the Switch/Keep swap prompt is removed — ?pkg= always starts a
     fresh config for that package. The host just stays empty now. */
  function renderSwapPrompt() {
    var host = document.querySelector("[data-bk-welcome]");
    if (!host) return;
    host.innerHTML = "";
  }

  function renderSummary() {
    var host = document.querySelector("[data-bk-summary]");
    var d = config(), mk = marketKey(), mkt = market();
    var title = d ? pkgOf(d.pkg).name : "Fall 2026";
    var html = '<span class="kicker">' + (state.editIndex !== null ? "Editing" : "Configuring") + '</span><h3>' + esc(title) + '</h3><div class="lines">';
    if (d) {
      html += '<div class="line"><span>' + esc(pkgOf(d.pkg).name) + "</span><b>" + fmt(pkgOf(d.pkg).price) + "</b></div>";
      entryChosen(d).forEach(function (a) {
        var nm = a.qty && entryQty(a, d) > 1 ? a.name + " × " + entryQty(a, d) : a.name;
        html += '<div class="line"><span>+ ' + esc(nm) + "</span><b>" + fmt(entryAPrice(a, d)) + "</b></div>";
      });
      html += '<div class="line"><span>Package total</span><b>' + fmt(entryUnitTotal(d)) + "</b></div>";
    } else {
      html += '<div class="line"><span class="muted">Package — step 1</span><b>—</b></div>';
    }
    /* the empty "Delivery week —" row was dead weight pre-selection (design pass, Aug-11) */
    if (state.week) html += '<div class="line"><span>Delivery week</span><b>' + esc(state.week) + "</b></div>";
    /* The ZIP's zone fee, quoted as an ESTIMATE in the same voice as tax — it is
       charged as a delivery rate against the address entered at checkout, not as a
       line we control, so this panel can preview it but must never fold it into a
       headline (Aug-12, Jeff). Only while the cart is empty: once there are lines the
       fee belongs to the whole order and the "In your cart" peek below speaks for it. */
    if (d && !state.entries.length) {
      var z = zone();
      if (z && z.fee) {
        html += '<div class="line"><span>Delivery zone fee</span><b class="muted">added at checkout · est. ' + fmt(z.fee) + "</b></div>";
      }
    }
    html += "</div>";
    if (state.entries.length) {
      var m = cartMoney();
      html += '<div class="money"><a class="cart-peek" href="/cart"><span>In your cart · ' + cartCount() + (cartCount() === 1 ? " package" : " packages") + "</span><b>" + fmt(m.due) + " →</b></a></div>";
    }
    /* Oct-8 per Jeff: the porches-remain / capacity-limited line is gone —
       scarcity copy is off the site. Week availability (open/low/full) stays:
       that one is real. */
    /* Aug-12 (Jeff): the "keeps for 7 days" auto-save note is not advertised —
       the draft still saves; the bbar's transient "Saved ✓" is the only signal. */
    html += '<p class="note">Payment in full at checkout. ' + esc((CFG.taxNotes && CFG.taxNotes[mk]) || "") + "</p>";
    host.innerHTML = html;
  }

  function renderBar() {
    var bar = document.querySelector("[data-bk-bar]");
    if (!bar) return;
    var d = config();
    bar.hidden = !d;
    if (!d) return;
    var sum = bar.querySelector("[data-bk-bar-sum]");
    var tot = bar.querySelector("[data-bk-bar-tot]");
    if (sum) sum.innerHTML = "<b>" + esc(pkgOf(d.pkg).name) + "</b> · Step " + state.step + " of " + stepLabels().length;
    /* Goods only — the zone fee is a checkout delivery rate now, not ours to add. */
    if (tot) tot.textContent = fmt(entryUnitTotal(d));
  }

  function renderChrome() {
    var label = document.querySelector("[data-bk-market-label]");
    if (label) label.textContent = market().label + " · Fall 2026";
    /* Aug-12 (Jeff): the header ZIP chip is GONE — it mirrored the in-flow field
       two inches away and the two could disagree mid-edit. The permanent field
       in the flow is the only ZIP surface on this page. */
    var cartlink = document.querySelector("[data-bk-cartlink]");
    if (cartlink) {
      cartlink.hidden = !state.entries.length;
      var t = cartlink.querySelector("[data-bk-cartlink-total]");
      if (t && state.entries.length) t.textContent = fmt(cartMoney().due);
    }
  }

  function render() {
    renderStepper();
    var host = document.querySelector("[data-bk-step]");
    host.innerHTML = [null, renderStep2, renderStep3][state.step]();
    renderSwapPrompt();
    renderSummary();
    renderBar();
    renderChrome();
    bind(host);
    saveDraft();
  }

  function keyToggles(el, fn) {
    el.addEventListener("keydown", function (ev) {
      if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); fn(); }
    });
  }

  function bindWaitForm(host) {
    var wait = host.querySelector("[data-bk-wait]");
    if (wait) wait.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var email = (wait.querySelector("input").value || "").trim();
      if (!email) return;
      var backend = MD && MD.backend ? MD.backend.replace(/\/$/, "") : "";
      if (backend) {
        fetch(backend + "/waitlist", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email, zip: zipDigits() })
        }).catch(function () {});
      }
      state.waitJoined = true;
      updateZipGate(document.querySelector("[data-bk-step]") || document);
    });
  }

  /* v3 of the ZIP gate (Aug-12). Root cause of every prior failure: re-rendering
     the step on keystrokes destroyed the focused input, the browser fired blur on
     the dying element, and downstream logic misread that as the customer leaving —
     the card vanished on the 5th digit. THE GATE IS STABLE DOM NOW: typing only
     rewrites the message area and toggles the add-on lock in place. Nothing else
     on the screen moves. The card settles to the slim strip ONLY on a real
     departure (blur of a still-attached input, or Enter). */
  function updateZipGate(host) {
    var gate = host.querySelector("[data-bk-zipgate]");
    if (!gate) return;
    var zs = zipStatus(), ok = zs.status === "ok";
    gate.classList.toggle("is-ok", ok);
    gate.classList.toggle("is-active", !ok);
    var msgCls = ok ? "ok" : (zs.status === "idle" ? "" : "out");
    var body = gate.querySelector(".zg-body");
    if (body) {
      body.innerHTML = '<p class="zg-msg ' + msgCls + '" data-bk-zipmsg aria-live="polite">' + esc(zipMsgFor(zs)) + "</p>" +
        (ok ? '<p class="zg-sub">' + esc(zone().note) + "</p>" : "") +
        (zs.status === "out" ? (state.waitJoined
          ? '<p class="gz-joined">You’re on the list — we’ll write the moment we expand ✓</p>'
          : '<form class="wait-row" data-bk-wait><input type="email" required placeholder="you@example.com" aria-label="Email address"><button class="btn btn-ghost" type="submit">Join the waitlist</button></form>') : "");
      bindWaitForm(host);
    }
    var check = gate.querySelector(".zg-check");
    if (check) check.style.opacity = ok ? "1" : "0"; /* inline — immune to cascade surprises */
    var rows = host.querySelector(".arows");
    if (rows) rows.classList.toggle("is-locked", !ok);
    host.querySelectorAll("[data-bk-addon]").forEach(function (r) {
      r.setAttribute("aria-disabled", String(!ok));
      r.setAttribute("tabindex", ok ? "0" : "-1");
    });
    host.querySelectorAll("[data-bk-awk]").forEach(function (r) {
      var sel = r.getAttribute("data-bk-awk") === state.removalWeek;
      r.setAttribute("aria-disabled", String(!ok));
      r.setAttribute("tabindex", ok ? (sel ? "0" : "-1") : "-1");
    });
    /* the note HOLDS ITS SPACE when satisfied — removing it pulled the add-on
       list up 38px right as the customer reached for it (measured, Aug-12) */
    var note = host.querySelector(".lock-note");
    if (!note && rows) {
      note = document.createElement("p");
      note.className = "lock-note";
      rows.parentNode.insertBefore(note, rows);
    }
    if (note) {
      note.textContent = "Confirm your ZIP above to unlock add-ons.";
      note.style.visibility = ok ? "hidden" : "visible";
    }
    host.querySelectorAll("[data-bk-next], [data-bk-addtocart]").forEach(function (b) {
      b.classList.toggle("is-disabled", !ok);
    });
    renderSummary();
    renderBar();
  }

  function focusZip() {
    var el = document.querySelector("#bk-zipcheck");
    if (el) { var v = el.value; el.focus({ preventScroll: true }); el.value = ""; el.value = v; }
  }
  function updateQty(id) {
    var row = document.querySelector('[data-bk-addon="' + id + '"]');
    if (!row) return;
    var d = config(), a = addonById(id), q = state.aqty[id] || 1;
    var b = row.querySelector(".qty b");
    if (b) b.textContent = q;
    /* the row's amount stays "$X ea" at any quantity (Jeff, Aug-11) — the line
       total lives in the summary, which re-renders below */
    renderSummary();
    renderBar();
  }

  /* Updated in place rather than through render(): a full re-render replaces the DOM and
     drops focus, which makes arrow-key navigation of a radiogroup unusable. Price is
     identical across weeks, so the summary and bar have nothing to recompute — they are
     refreshed anyway, cheaply, in case a future week-choice add-on prices weeks apart. */
  function updateWeekChoice(host, focusIt) {
    var opts = (host || document).querySelectorAll("[data-bk-awk]");
    var locked = zipStatus().status !== "ok";
    opts.forEach(function (el) {
      var sel = el.getAttribute("data-bk-awk") === state.removalWeek;
      el.classList.toggle("is-sel", sel);
      el.setAttribute("aria-checked", String(sel));
      el.setAttribute("aria-disabled", String(locked));
      el.setAttribute("tabindex", locked ? "-1" : (sel ? "0" : "-1"));
      if (sel && focusIt) el.focus({ preventScroll: true });
    });
    renderSummary();
    renderBar();
    saveDraft();
  }

  function bind(host) {
    host.querySelectorAll("[data-bk-back]").forEach(function (b) {
      b.addEventListener("click", function () { go(Math.max(1, state.step - 1)); });
    });
    host.querySelectorAll("[data-bk-next]").forEach(function (b) {
      b.addEventListener("click", function () { go(state.step + 1); });
    });
    var atc = host.querySelector("[data-bk-addtocart]");
    if (atc) atc.addEventListener("click", addToCart);
    host.querySelectorAll("[data-bk-pkg]").forEach(function (card) {
      var pick = function () { state.pkg = card.getAttribute("data-bk-pkg"); go(1); };
      card.addEventListener("click", pick);
      keyToggles(card, pick);
    });
    host.querySelectorAll("[data-bk-addon]").forEach(function (row) {
      var id = row.getAttribute("data-bk-addon");
      var toggle = function () {
        if (zipStatus().status !== "ok") return;
        state.on[id] = !state.on[id];
        var a = addonById(id);
        if (a && a.qty && state.on[id] && !state.aqty[id]) state.aqty[id] = 1;
        render();
      };
      row.addEventListener("click", function (ev) {
        if (ev.target && ev.target.closest && ev.target.closest("a")) return; /* policy link, not a toggle */
        toggle();
      });
      keyToggles(row, toggle);
    });
    host.querySelectorAll("[data-bk-plus]").forEach(function (b) {
      b.addEventListener("click", function (ev) {
        ev.stopPropagation();
        var id = b.getAttribute("data-bk-plus");
        state.aqty[id] = Math.min(12, (state.aqty[id] || 1) + 1);
        updateQty(id);
        saveDraft();
      });
    });
    host.querySelectorAll("[data-bk-minus]").forEach(function (b) {
      b.addEventListener("click", function (ev) {
        ev.stopPropagation();
        var id = b.getAttribute("data-bk-minus");
        state.aqty[id] = Math.max(1, (state.aqty[id] || 1) - 1);
        updateQty(id);
        saveDraft();
      });
    });

    /* ZIP gate: targeted updates while typing (no focus loss); a ZIP from another
       metro switches the whole page to that metro (labels, weeks, tax) in place. */
    var zipInput = host.querySelector("#bk-zipcheck");
    if (zipInput) {
      zipInput.addEventListener("input", function () {
        state.zip = zipInput.value;
        var zs = zipStatus();
        if (zs.status === "other") {
          /* a cross-metro ZIP relabels the whole page — the one case that must
             re-render. Keep the gate open and put focus straight back. */
          switchMarket(zs.other);
          state.zipOpen = true;
          render(); focusZip();
          return;
        }
        if (zs.status === "ok") state.marketOverride = marketKey(); /* pin metro */
        updateZipGate(host); /* message + add-on lock update in place; the input is untouched */
      });
      zipInput.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter") ev.preventDefault(); /* nothing to submit — validation is inline */
      });
    }

    /* Week-choice radios. Enter/Space select; arrows move AND select, which is the
       ARIA radiogroup convention and what a screen-reader user will expect here. */
    var awk = Array.prototype.slice.call(host.querySelectorAll("[data-bk-awk]"));
    awk.forEach(function (el, i) {
      var pick = function () {
        if (zipStatus().status !== "ok") return;
        state.removalWeek = weekChoiceKey(el.getAttribute("data-bk-awk"));
        updateWeekChoice(host, false);
      };
      el.addEventListener("click", pick);
      el.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); pick(); return; }
        var d = (ev.key === "ArrowRight" || ev.key === "ArrowDown") ? 1
              : (ev.key === "ArrowLeft" || ev.key === "ArrowUp") ? -1 : 0;
        if (!d || awk.length < 2) return;
        ev.preventDefault();
        if (zipStatus().status !== "ok") return;
        var next = awk[(i + d + awk.length) % awk.length];
        state.removalWeek = weekChoiceKey(next.getAttribute("data-bk-awk"));
        updateWeekChoice(host, true);
      });
    });

    bindWaitForm(host);
    host.querySelectorAll("[data-bk-week]").forEach(function (b) {
      b.addEventListener("click", function () {
        state.week = b.getAttribute("data-bk-week");
        render();
      });
    });
  }

  function bootFlow() {
    PAGE = "flow";
    var restored = loadDraft();
    if (restored) applyDraft(restored);

    var params = null;
    try { params = new URLSearchParams(location.search); } catch (e) {}
    var pkgParam = params && params.get("pkg");
    var editParam = params && params.get("edit");
    var weekParam = params && params.get("week");
    var zipParam = params && params.get("zip");

    if (editParam !== null && state.entries[+editParam]) {
      /* pencil edit from the cart: load that line into the config */
      var e = state.entries[+editParam];
      state.editIndex = +editParam;
      state.pkg = e.pkg;
      state.on = JSON.parse(JSON.stringify(e.on || {}));
      state.aqty = JSON.parse(JSON.stringify(e.aqty || {}));
      state.step = 1;
    } else if (weekParam) {
      state.weekOnly = true;
      state.step = 2;
    } else if (zipParam) {
      if (!state.pkg) { location.replace("/pages/packages"); return; }
      state.zipOpen = true;
      state.step = 1;
    } else if (pkgParam && pkgOf(pkgParam)) {
      /* Aug-11 (Jeff): the Switch/Keep swap prompt is GONE. Landing here with a
         package always configures THAT package; an unfinished config for a
         different one is simply discarded — navigating away before "Add to cart"
         means starting over, which doubles as changing your mind. */
      if (state.pkg && state.pkg !== pkgParam) {
        state.on = {}; state.aqty = {};
      }
      state.pkg = pkgParam;
      state.step = 1;
    } else if (restored && state.pkg) {
      state.step = 1; /* resume the in-progress config at add-ons */
    } else {
      /* No package to configure — the picker step is gone, so send them to the
         page that chooses packages instead of showing an empty flow. */
      location.replace("/pages/packages");
      return;
    }
    if (state.step > 1 && !state.weekOnly && zipStatus().status !== "ok") state.step = 1;

    /* cold start with no ZIP: inherit the one typed into the homepage hero,
       so nobody types their ZIP twice (Aug-12, with the chip removal). */
    if (!state.zip) {
      try { var heroZip = localStorage.getItem("gp-zip"); if (heroZip) state.zip = heroZip; } catch (e) {}
    }

    render();
    document.addEventListener("gp:metro", function () { if (PAGE === "flow") render(); });
  }

  /* ============================================================
     PAGE: CART (/cart)
     ============================================================ */
  /* Removal is instant but reversible for a few seconds — a configured package
     is many decisions; a mis-tap shouldn't destroy them (staff-designer pass, Aug-11). */
  var undoEl = null, undoTimer = null;
  function dismissUndo() {
    if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
    if (undoEl && undoEl.parentNode) undoEl.parentNode.removeChild(undoEl);
    undoEl = null;
  }
  function showUndo(name, entry, index, extraLines, week) {
    dismissUndo();
    undoEl = document.createElement("div");
    undoEl.className = "gpc-undo";
    undoEl.setAttribute("role", "status");
    undoEl.innerHTML = "Removed " + esc(name) + ' <button type="button">Undo</button>';
    undoEl.querySelector("button").addEventListener("click", function () {
      state.entries.splice(Math.min(index, state.entries.length), 0, entry);
      if (week && !state.week) state.week = week; /* the week left with the last line — bring it back with it */
      dismissUndo();
      renderCart(extraLines);
      saveDraft();
    });
    document.body.appendChild(undoEl);
    undoTimer = setTimeout(dismissUndo, 6000);
  }

  function cartLineHtml(e, i) {
    var p = pkgOf(e.pkg), q = e.qty || 1;
    var hasMums = !!p.mums || !!(e.on && (e.on.mums || e.on["mums-lg"]));
    var care = hasMums ? '<p class="gpc-care">' + esc(MUMS_CART) + (isPhoenix() ? " " + esc(MUMS_PHX) : "") + MUMS_LINK + "</p>" : "";
    /* Add-ons as a labeled comma list; remove is a plain "Remove" next to the qty
       stepper (Jeff, Aug-11). Same day: every line shows its math — base price +
       per-add-on prices — so the total is verifiable right where the sales-final
       box gets ticked; nobody should have to reopen Edit to check what they owe. */
    var chosen = entryChosen(e);
    var names = chosen.map(function (a) {
      var label = a.qty && entryQty(a, e) > 1 ? a.name + "\u00a0×\u00a0" + entryQty(a, e) : a.name;
      return esc(label) + '\u00a0<span class="gpc-sub-amt">' + fmt(entryAPrice(a, e)) + "</span>";
    });
    var addonSum = chosen.reduce(function (s2, a) { return s2 + entryAPrice(a, e); }, 0);
    /* Package/Add-ons amounts sit under the package NAME (head column); the
       add-on list + care note fill the full width below (Jeff, Aug-11). */
    var headSubs = names.length
      ? '<p class="gpc-base"><span class="gpc-k">Package</span><span class="gpc-sub-amt">' + fmt(p.price) + '</span></p>' +
        '<p class="gpc-base"><span class="gpc-k">Add-ons</span><span class="gpc-sub-amt">' + fmt(addonSum) + "</span></p>"
      : "";
    var subs = names.length
      ? '<p class="gpc-subs">' + names.join(", ") + "</p>"
      : '<p class="gpc-subs gpc-subs-none">No add-ons</p>';
    /* Photo + name + price on one top row; the itemized body gets the full column
       width below it — beside a 72px photo the receipt wrapped into an 8-line
       skinny column on phones (Jeff, Aug-11). */
    return '<div class="gpc-line">' +
      '<div class="gpc-line-top">' +
      '<img class="gpc-photo" alt="' + esc(p.name) + '" src="' + esc(pkgPhoto(p)) + '">' +
      '<span class="gpc-line-head"><h3>' + esc(p.name) + "</h3>" + headSubs + "</span>" +
      '<span class="gpc-line-right"><b class="gpc-line-total">' + fmt(entryUnitTotal(e) * q) + "</b></span>" +
      "</div>" +
      '<div class="gpc-line-body">' + subs + care + "</div>" +
      '<span class="gpc-line-foot">' +
      '<span class="qty"><button type="button" data-gpc-minus="' + i + '" aria-label="Fewer"' + (q <= 1 ? " disabled" : "") + '>−</button><b>' + q + '</b><button type="button" data-gpc-plus="' + i + '" aria-label="More">+</button></span>' +
      (q > 1 ? '<span class="gpc-unit">' + fmt(entryUnitTotal(e)) + " each</span>" : "") +
      '<button class="gpc-edit" type="button" data-gpc-edit="' + i + '" aria-label="Edit ' + esc(p.name) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg> Edit</button>' +
      '<button class="gpc-remove" type="button" data-gpc-remove="' + i + '" aria-label="Remove ' + esc(p.name) + '">Remove</button>' +
      "</span>" +
      "</div>";
  }

  /* Delivery ZIP, edited in place on the cart (Aug-12, Jeff).
     The old "Edit" linked to /pages/book?zip=1, but that route needs a package in
     progress — and "Add to cart" clears it — so from the cart it ALWAYS bounced to
     /pages/packages. The ZIP now edits right in the panel, and the zone fee, tax
     and total below it recompute on save. */
  function cartZipMsg(zs) {
    if (zs.status === "ok") return "You’re in our " + zone().gate + ".";
    if (zs.status === "other") return "That ZIP is in our " + MD.markets[zs.other].label + " area — saving switches your order over.";
    if (zs.status === "out") return "We’re not in that neighborhood yet — check the ZIP, or use one we deliver to.";
    return "Enter your 5-digit delivery ZIP.";
  }
  function cartZipLineHtml(zs, z) {
    if (!state.zipEditing) {
      return '<div class="line"><span>Delivery ZIP</span><b>' +
        (zs.status === "ok" ? esc(zipDigits()) + " · " + esc(z.short) : "—") +
        ' <button class="gpc-chg" type="button" data-gpc-zipedit>Edit</button></b></div>';
    }
    return '<div class="line gpc-ziprow"><span>Delivery ZIP</span>' +
      '<b><input id="gpc-zipinput" inputmode="numeric" maxlength="5" placeholder="80209" aria-label="Delivery ZIP code" value="' + esc(state.zip) + '">' +
      '<button class="gpc-chg" type="button" data-gpc-zipsave>Save</button></b></div>' +
      '<p class="gpc-zipmsg ' + zipMsgCls(zs) + '" data-gpc-zipmsg aria-live="polite">' + esc(cartZipMsg(zs)) + "</p>";
  }
  function zipMsgCls(zs) { return zs.status === "ok" ? "ok" : (zs.status === "idle" ? "" : "out"); }
  function commitCartZip(extraLines) {
    if (!state.zipEditing) return;
    var zs = zipStatus();
    /* A ZIP from another metro moves the whole order — weeks, tax and availability
       key off the metro. switchMarket drops a week that metro doesn't offer, and
       the panel then shows "—" with its Change link. */
    if (zs.status === "other") switchMarket(zs.other);
    if (zipStatus().status === "ok") {
      state.marketOverride = marketKey();
      try { localStorage.setItem("gp-zip", zipDigits()); } catch (e) {} /* one ZIP, typed once */
    }
    state.zipEditing = false;
    renderCart(extraLines);
    saveDraft();
  }

  function renderCart(extraLines) {
    var host = document.querySelector("[data-gpc-root]");
    if (!host) return;
    if (!state.entries.length && !(extraLines && extraLines.length)) {
      host.innerHTML = '<div class="gpc-empty"><p>Your cart is empty.</p>' +
        '<a class="btn btn-primary" href="/pages/packages">View the packages <span class="arrow">→</span></a></div>';
      saveDraft();
      announceCartExact(0);
      return;
    }
    var zs = zipStatus(), z = zone(), m = cartMoney();
    var html = '<div class="gpc-grid"><div>';
    html += '<div class="gpc-lines">';
    state.entries.forEach(function (e, i) { html += cartLineHtml(e, i); });
    html += "</div>";
    if (extraLines && extraLines.length) {
      html += '<div class="gpc-extra"><h4>Also in your cart</h4>';
      extraLines.forEach(function (it) {
        html += '<div class="gpc-extra-line"><span>' + esc(it.title) + (it.quantity > 1 ? " × " + it.quantity : "") + "</span><b>" + fmt(it.line_price / 100) + "</b></div>";
      });
      html += "</div>";
    }
    html += '<a class="gpc-continue" href="/pages/packages">+ Add another package</a>';
    html += "</div>";

    /* order panel */
    html += '<aside class="osum gpc-panel">';
    html += '<span class="kicker">Your order</span>';
    html += '<div class="lines">';
    /* A gift card isn't delivered by us and carries no package terms, so a
       cart holding only one shows none of the delivery chrome (Jeff, Aug-12). */
    if (state.entries.length) {
      html += '<div class="line"><span>Delivery week</span><b>' + esc(state.week || "—") + ' <a class="gpc-chg" href="/pages/book?week=1">Change</a></b></div>';
      html += cartZipLineHtml(zs, z);
    } else {
      html += '<div class="line"><span>Gift card</span><b>Emailed after checkout</b></div>';
    }
    html += "</div>";
    html += '<div class="money">';
    html += '<div class="mline"><span>Subtotal</span><b>' + fmt(m.subtotal) + "</b></div>";
    /* Estimate, in the same voice as tax: Shopify charges this as a delivery rate
       against the address entered at checkout, so the exact figure depends on where
       they actually ship, not on the ZIP typed here (Aug-12, Jeff). */
    if (m.fee) html += '<div class="mline gpc-taxline"><span>Delivery zone fee</span><b>added at checkout · est. ' + fmt(m.fee) + "</b></div>";
    /* The estimated sales-tax row is gone (Aug-13, Jeff): checkout shows the real
       figure on the very next screen, so an estimate here only invites a mismatch
       between two numbers the customer sees seconds apart. The note below still says
       tax is added at checkout by delivery address, so nothing is hidden. */
    html += '<div class="due"><span>Total at checkout</span><b>' + fmt(m.due) + "</b></div></div>";
    html += '<p class="note">' + (state.entries.length
      ? esc(z ? z.note : "") + " Payment in full at checkout — sales tax is added there by your delivery address, and discount codes are entered there."
      : "Payment in full at checkout. Gift cards aren’t taxed when bought — tax applies to what they’re redeemed against.") + "</p>";
    if (state.entries.length) {
      /* A textarea, not an input (Aug-13, Jeff): gate codes and step directions run
         past one line, and a single-line field hid the start of what they'd typed.
         Two rows to begin with, then it grows to fit — see the autogrow below. */
      html += '<div class="gp-gfield gpc-notes"><label for="gpc-notes">Porch notes <span style="text-transform:none;letter-spacing:0">(optional)</span></label><textarea id="gpc-notes" rows="2" placeholder="Gate code, steps, pets…">' + esc(state.notes || "") + '</textarea></div>';
      if (hasDesign()) {
        html += '<div class="terms-row gpc-release"><input type="checkbox" data-gpc-release aria-labelledby="gpc-release-text"' + (state.photoOk ? " checked" : "") + '>' +
          '<span id="gpc-release-text">I consent to Gourdgeous Porches using photos/video of my porch for promotional purposes, including social media, without compensation.</span></div>';
      }
      html += '<div class="terms-row gpc-terms"><input type="checkbox" data-gpc-terms aria-labelledby="gpc-terms-text"' + (state.termsAccepted ? " checked" : "") + '><span id="gpc-terms-text">' + termsHtml() + "</span></div>";
    }
    var ready = !checkoutBlocker();
    html += '<button class="btn btn-primary gpc-checkout' + (ready ? "" : " is-waiting") + '" type="button" data-gpc-checkout aria-disabled="' + !ready + '">Checkout</button>';
    /* Phones: the order card sits a viewport+ below the lines, so a slim sticky
       bar keeps the labeled total and the one primary action in view (staff-
       designer pass, Aug-11). Same submit path — blocker messages still fire. */
    html += '<div class="gpc-stickybar"><span>Total at checkout <b>' + fmt(m.due) + '</b></span><button class="btn btn-primary' + (ready ? "" : " is-waiting") + '" type="button" data-gpc-checkout aria-disabled="' + !ready + '">Checkout</button></div>';
    if (!state.entries.length) { /* gift card only — nothing to confirm */ }
    else if (!state.week) html += '<p class="gpc-hint">Pick a delivery week to check out.</p>';
    else if (zs.status !== "ok") html += '<p class="gpc-hint">Confirm your delivery ZIP to check out.</p>';
    html += '<p class="promo-msg err" data-gpc-err hidden></p>';
    html += "</aside></div>";
    host.innerHTML = html;

    /* handlers */
    host.querySelectorAll("[data-gpc-edit]").forEach(function (b) {
      b.addEventListener("click", function () {
        saveDraft();
        location.href = "/pages/book?edit=" + b.getAttribute("data-gpc-edit");
      });
    });
    host.querySelectorAll("[data-gpc-remove]").forEach(function (b) {
      b.addEventListener("click", function () {
        var i = +b.getAttribute("data-gpc-remove");
        var e = state.entries[i];
        if (!e) return;
        state.entries.splice(i, 1);
        /* Aug-12 (Jeff): the delivery week belongs to the ORDER — an empty cart has
           no week to deliver. Leaving it set meant coming back to configure a fresh
           package showed a week the customer never picked for it. Undo restores it. */
        var week = state.week;
        if (!state.entries.length) state.week = null;
        renderCart(extraLines);
        saveDraft();
        showUndo(pkgOf(e.pkg).name, e, i, extraLines, week);
      });
    });
    host.querySelectorAll("[data-gpc-plus]").forEach(function (b) {
      b.addEventListener("click", function () {
        var e = state.entries[+b.getAttribute("data-gpc-plus")];
        if (e) e.qty = Math.min(MAX_QTY, (e.qty || 1) + 1);
        renderCart(extraLines);
        saveDraft();
      });
    });
    host.querySelectorAll("[data-gpc-minus]").forEach(function (b) {
      b.addEventListener("click", function () {
        var i = +b.getAttribute("data-gpc-minus");
        var e = state.entries[i];
        if (!e || (e.qty || 1) <= 1) return; /* − never deletes; Remove (with undo) is the explicit path */
        e.qty -= 1;
        renderCart(extraLines);
        saveDraft();
      });
    });
    var zipEdit = host.querySelector("[data-gpc-zipedit]");
    if (zipEdit) zipEdit.addEventListener("click", function () {
      state.zipEditing = true;
      renderCart(extraLines);
      var el = host.querySelector("#gpc-zipinput");
      if (el) { el.focus(); el.select(); }
    });
    var zipInput = host.querySelector("#gpc-zipinput");
    if (zipInput) {
      /* Typing rewrites ONLY the message line. Re-rendering the panel on each
         keystroke would destroy the focused input — the same trap documented on
         the flow's ZIP gate. The money recomputes when the edit is committed. */
      zipInput.addEventListener("input", function () {
        state.zip = zipInput.value;
        var msg = host.querySelector("[data-gpc-zipmsg]"), zs2 = zipStatus();
        if (msg) { msg.textContent = cartZipMsg(zs2); msg.className = "gpc-zipmsg " + zipMsgCls(zs2); }
      });
      zipInput.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter") { ev.preventDefault(); commitCartZip(extraLines); }
      });
      zipInput.addEventListener("blur", function () { commitCartZip(extraLines); });
    }
    var zipSave = host.querySelector("[data-gpc-zipsave]");
    if (zipSave) {
      zipSave.addEventListener("mousedown", function (ev) { ev.preventDefault(); }); /* let the click land, not blur */
      zipSave.addEventListener("click", function () { commitCartZip(extraLines); });
    }
    var notes = host.querySelector("#gpc-notes");
    if (notes) {
      /* Grow to fit rather than scrolling inside two rows — the whole point of the
         field is that the crew reads it, so the customer should see all of what
         they wrote. Reset to auto first or the height only ever ratchets up. */
      var growNotes = function () {
        notes.style.height = "auto";
        notes.style.height = notes.scrollHeight + "px";
      };
      notes.addEventListener("input", function () { state.notes = notes.value; growNotes(); saveDraft(); });
      growNotes(); /* a restored draft can already be several lines long */
    }
    var photo = host.querySelector("[data-gpc-release]");
    if (photo) photo.addEventListener("change", function () { state.photoOk = photo.checked; saveDraft(); });
    var terms = host.querySelector("[data-gpc-terms]");
    if (terms) terms.addEventListener("change", function () {
      state.termsAccepted = terms.checked;
      var ok2 = !checkoutBlocker();
      host.querySelectorAll("[data-gpc-checkout]").forEach(function (btn) {
        btn.classList.toggle("is-waiting", !ok2);
        btn.setAttribute("aria-disabled", String(!ok2));
      });
      var err = host.querySelector("[data-gpc-err]");
      if (ok2 && err) err.hidden = true;
    });
    host.querySelectorAll("[data-gpc-checkout]").forEach(function (co) {
      co.addEventListener("click", function () {
        submitCheckout(co, host.querySelector("[data-gpc-err]"));
      });
    });
    saveDraft();
    announceCartExact(m.due);
  }

  function bootCart() {
    PAGE = "cart";
    var restored = loadDraft();
    if (restored) applyDraft(restored);
    fetch("/cart.js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        /* Rebuild ONLY when there is no draft at all — that's the case this was
           built for: the draft is cleared at checkout handoff, so a customer who
           backs out of checkout still finds their order here. Keying it on "no
           entries" instead resurrected packages the customer had just removed:
           removal empties the draft's entries but leaves the Shopify cart's
           booking lines untouched, so the next load read them straight back in
           (Jeff, Aug-12). A draft that exists is the answer, empty or not. */
        if (!restored && c) rebuildFromCart(c);
        var known = bookingVariantSet();
        var extra = c ? (c.items || []).filter(function (it) { return !known[it.variant_id]; }) : [];
        extraCart = extra;
        /* Removing the last package empties the draft's entries but never touched
           Shopify's cart — booking lines are only zeroed at checkout handoff. The page
           then read "Your cart is empty" off the draft while the header badge kept
           counting the orphaned lines, and they would ride into checkout on the next
           sync (Jeff, Aug-13). Zero them here so the two agree.

           Safe because a draft that EXISTS and holds no entries can only mean removal:
           saveDraft() deletes the draft outright once package, ZIP and week are all
           gone, and checkout handoff calls clearDraft(), so in both of those cases
           `restored` is falsy and rebuildFromCart() above has already repopulated
           entries. Backing out of checkout still finds the order here. */
        var orphans = {};
        if (restored && !state.entries.length && c) {
          (c.items || []).forEach(function (it) { if (known[it.variant_id]) orphans[it.key] = 0; });
        }
        if (Object.keys(orphans).length) {
          return fetch("/cart/update.js", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: orphans })
          }).then(function () { renderCart(extra); })
            .catch(function () { renderCart(extra); });
        }
        renderCart(extra);
      })
      .catch(function () { extraCart = []; renderCart([]); });
  }

  /* ---------- boot ---------- */
  function boot() {
    CFG = parseJSON("gp-booking-data");
    MD = parseJSON("gp-market-data");
    if (!CFG || !MD) return;
    if (document.querySelector("[data-gpc-root]")) { bootCart(); return; }
    if (document.querySelector("[data-bk-step]")) bootFlow();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();
